<template>
  <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
    @before-open="beforeOpen" :adaptive="true">
    <div class="modal-container">
      <div class="create-modal-header">
        <h3>Create Incident</h3>
        <button @click=close>X</button>
      </div>
      <div class="modal-content">
        <div class="modal-intro-information">
          <label>Title:</label>
          <input ref="title" type="text" placeholder="Incident Title" class="modal-incident-title" v-model="title" />
          <label>Description:</label>
          <textarea ref="description" type="text" placeholder="Description" class="modal-incident-description"
            maxlength="200" rows="5" v-model="description"></textarea>
        </div>
        <div class="modal-create-data">
          <div class="modal-create-data-item">
            <p class="item-header">Incident Type</p>
            <div @mouseleave="showTypes = false" style="flex:1; display: flex;" ref="type">
              <option-dropdown-select v-if="showTypes" class="search" style="top: 36px" :options="mappedTypes"
                 :onOptionSelected="(option, event) => {
                  event.stopImmediatePropagation()
                  setType(option.value);
                  showTypes = false
                }" />
              <button v-else-if="selectedType != null" class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <p style="text-align: center;" @mousedown="showTypes = !showTypes">
                  {{ selectedType }}</p>
              </button>
              <button v-else class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <div
                  style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                  @mousedown="showTypes = !showTypes">
                  <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Incident Status</p>
            <div @mouseleave="showStatuses = false" style="flex:1; display: flex;" ref="status">
              <option-dropdown-select v-if="showStatuses" class="search" style="top: 36px" :options="mappedStatuses"
                 :onOptionSelected="(option, event) => {
                  event.stopImmediatePropagation()
                  setStatus(option.value);
                  showStatuses = false
                }" />
              <button v-else-if="selectedStatus != null" class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <p style="text-align: center;" @mousedown="showStatuses = !showStatuses">
                  {{ selectedStatus }}</p>
              </button>
              <button v-else class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <div
                  style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                  @mousedown="showStatuses = !showStatuses">
                  <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Incident Priority</p>
            <div @mouseleave="showPriorities = false" style="flex:1; display: flex;" ref="priority">
              <option-dropdown-select v-if="showPriorities" class="search" style="top: 36px" :options="mappedPriorities"
                :onOptionSelected="(option, event) => {
                  event.stopImmediatePropagation()
                  setPriority(option.value);
                  showPriorities = false
                }" />
              <button v-else-if="selectedPriority != null" class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <p style="text-align: center;" @mousedown="showPriorities = !showPriorities">
                  {{ selectedPriority }}</p>
              </button>
              <button v-else class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <div
                  style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                  @mousedown="showPriorities = !showPriorities">
                  <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Location</p>
            <div @mouseleave="showLocations = false" style="flex:1; display: flex;" ref="location">
              <option-dropdown-select v-if="showLocations" class="search" style="top: 36px" :options="mappedLocations"
                :onOptionSelected="(option, event) => {
                  event.stopImmediatePropagation()
                  setLocation(option.value);
                  showLocations = false
                }" />
              <button v-else-if="selectedLocation != null" class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <p style="text-align: center;" @mousedown="showLocations = !showLocations">
                  {{ selectedLocation }}</p>
              </button>
              <button v-else class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <div
                  style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                  @mousedown="showLocations = !showLocations">
                  <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Associated Resident</p>
            <div @mouseleave="showResidentOptions = false" style="flex:1; display: flex;" ref="resident">
              <option-dropdown-select v-if="showResidentOptions" class="search" style="top: 36px" :openUpwards="true"
                :options="residentOptions" :searchCallback="(data) => fetchResidents(data)" :onOptionSelected="(option, event) => {
                  event.stopImmediatePropagation()
                  setSelectedResident(option.value);
                  showResidentOptions = false
                }" />
              <button v-else-if="residentData != null" class="option-select-dropdown-button"
                style="flex: 2; display: flex; align-items: center; justify-content: center;">
                <p style="text-align: center;" @click="showResidentOptions = !showResidentOptions">
                  {{ getSelectedResidentText() }}</p>
              </button>
              <button v-else class="option-select-dropdown-button"
                style="flex: 2; display: flex; align-items: center; justify-content: center;">
                <div
                  style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                  @click="showResidentOptions = !showResidentOptions">
                  <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Reported By</p>
            <button>{{ getReporterText() }}</button>
          </div>
          <div class="modal-create-data-item">
            <p>Assigned To</p>
            <div @mouseleave="showAssigneeOptions = false" style="flex:1; display: flex;" ref="assignee">
              <option-dropdown-select v-if="showAssigneeOptions" class="search" style="top: 36px" :openUpwards="true"
                :options="guardOptions" :onOptionSelected="(option, event) => {
                  event.stopImmediatePropagation()
                  setAssignee(option.value);
                  showAssigneeOptions = false
                }" />
              <button v-else-if="assigneeData != null" class="option-select-dropdown-button"
                style="flex: 2; display: flex; align-items: center; justify-content: center;">
                <p style="text-align: center;" @click="showAssigneeOptions = !showAssigneeOptions">
                  {{ getSelectedAssigneeText() }}</p>
              </button>
              <button v-else class="option-select-dropdown-button"
                style="flex: 2; display: flex; align-items: center; justify-content: center;">
                <div
                  style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                  @click="showAssigneeOptions = !showAssigneeOptions">
                  <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="createIncident()">Create Incident</button>
      </div>
    </div>
  </modal>
</template>

<script>
import * as Constants from "../../js/constants.js";
import CTSRepository from "../../js/CTSRepository.js";
import OptionDropdownSelect from "../layout/OptionDropdownSelect.vue";
const NAME = Constants.CREATE_INCIDENT_MODAL

export default {
  modalName: NAME,
  components: {
    OptionDropdownSelect
  },
  props: ["organizationData", "userData"],
  opened(event) {
    console.log('Opening...', event)
  },
  watch: {
    title(newValue) {
      if (newValue != "") this.$refs['title'].classList.remove('invalid')
    },
    description(newValue) {
      if (newValue != "") this.$refs['description'].classList.remove('invalid')
    },
  },
  data() {
    return {
      modalName: NAME,
      title: "",
      description: "",
      locationRef: this.$refs.location,
      selectedLocation: null,
      showLocations: false,
      locations: [
        { location_name: "Clubhouse" },
        { location_name: "Front Gate" },
        { location_name: "Back Gate" },
        { location_name: "Pool" },
        { location_name: "Basketball Court" },
        { location_name: "Tennis Court" },
      ],
      filteredLocations: null,
      selectedType: null,
      showTypes: false,
      types: [
        "Suspicious person or activity",
        "Trespassing",
        "Attempted unauthorized entry",
        "Theft / burglary",
        "Vandalism",
        "Altercation / fight",
        "Medical emergency",
        "Fire / fire alarm",
        "Police involvement",
        "Evacuation",
        "Welfare check",
        "Vehicle accident / collision",
        "Hit and run",
        "Reckless driving",
        "Traffic obstruction",
        "Vehicle breakdown blocking access",
        "Visitor refused entry",
        "Aggressive or non-compliant guest",
        "Guest removed from property",
        "Fake or invalid access credential",
        "Blacklisted guest attempt",
        "Unauthorized delivery attempt",
        "Missing / stolen package",
        "Vendor denied entry",
        "Vendor no-show / confusion at gate",
        "Weather damage (storm, flooding)",
        "Fallen trees / debris",
        "Road blockage",
        "Hazardous conditions (spills, ice, etc.)",
        "Resident complaint (non-rule specific)",
        "Lost & found",
        "Welfare concern",
        "Disturbance not tied to a clear violation"
      ],
      filteredTypes: null,
      selectedPriority: null,
      showPriorities: false,
      priorities: [
        "Urgent",
        "High",
        "Medium",
        "Low"
      ],
      filteredPriorities: null,
      selectedStatus: null,
      showStatuses: false,
      statuses: [
        "OPEN",
        "IN PROGRESS",
        "BLOCKED",
        "CLOSED"
      ],
      filteredStatuses: null,
      showResidents: false,
      selectedResident: null,
      selectedAssignee: null,
      showAssignees: false,
      residentData: null,
      residentOptions: [],
      showResidentOptions: false,
      guardData: null,
      guardOptions: [],
      showGuardOptions: false,
      assigneeData: null,
      assigneeOptions: [],
      showAssigneeOptions: false
    }
  },
  methods: {
    show() {
      this.$modal.show(NAME);
    },
    beforeOpen(event) {
      console.log('Before Opening...', event)
    },
    validateKey() {
      console.log("Validating key...")
    },
    close() {
      this.title = "";
      this.description = "";
      this.residentData = null;
      this.selectedType = null;
      this.selectedStatus = null;
      this.selectedPriority = null;
      this.selectedLocation = null;
      this.assigneeData = null;
      this.$modal.hide(NAME);
    },
    getReporterText() {
      const user = this.$props.userData
      return `${user.name} ${user.family_name} (${this.$roleNameMap[user['custom:cts_role']]})`
    },
    setLocation(location) {
      this.selectedLocation = location;
      this.showLocations = false;
      this.$refs['location'].classList.remove('invalid')
    },
    setType(type) {
      this.selectedType = type;
      this.showTypes = false;
      this.$refs['type'].classList.remove('invalid')
    },
    setPriority(priority) {
      this.selectedPriority = priority;
      this.showPriorities = false;
      this.$refs['priority'].classList.remove('invalid')
    },
    setStatus(status) {
      this.selectedStatus = status;
      this.showStatuses = false;
      this.$refs['status'].classList.remove('invalid')
    },
    setSelectedResident(resident) {
      this.selectedResident = resident;
      this.residentData = resident;
      console.log("Selected Resident", resident)
      this.showResidents = false;
      this.$refs['resident'].classList.remove('invalid')
    },
    setAssignee(user) {
      this.selectedAssignee = user;
      this.assigneeData = user
      this.showAssignees = false;
      console.log("Selected Assignee", user)

      this.$refs['assignee'].classList.remove('invalid')
    },
    getSelectedResidentText() {
      if (this.residentData === null) return ""
      else return `${this.residentData.first_name} ${this.residentData.last_name}`
    },
    getSelectedAssigneeText() {
      if (this.assigneeData === null) return ""
      else return `${this.assigneeData.first_name} ${this.assigneeData.last_name}`
    },
    inputsValid() {
      let selectedResidentVerified = this.selectedResident != null;
      let selectedTypeVerified = this.selectedType != null;
      let selectedTitleVerified = this.title != "";
      let selectedDescriptionVerified = this.description != "";
      let selecetdReporterVerified = this.$props.userData != null;
      let selecetdStatusVerified = this.selectedStatus != null;
      let selecetdPriorityVerified = this.selectedPriority != null;
      let selecetdLocationVerified = this.selectedLocation != null;
      let selectedAssigneeVerified = this.selectedAssignee != null;
      let warnings = []

      if (!selectedTitleVerified) {
        warnings.push("Input a title for this incident")
        this.$refs['title'].classList.add('invalid')
      }
      if (!selectedDescriptionVerified) {
        warnings.push("Input a description for this incident")
        this.$refs['description'].classList.add('invalid')
      }
      if (!selecetdLocationVerified) {
        warnings.push("Select a location for the incident")
        console.log("Location Ref", this.$refs['location'])
        this.$refs['location'].classList.add('invalid')
      }
      if (!selecetdReporterVerified) {
        warnings.push("Sign in to Create an Incident")
      }
      if (!selectedTypeVerified) {
        warnings.push("Select a type for the incident")
        this.$refs['type'].classList.add('invalid')
      }
      if (!selecetdStatusVerified) {
        warnings.push("Select a status for the incident")
        this.$refs['status'].classList.add('invalid')
      }
      if (!selecetdPriorityVerified) {
        warnings.push("Select a priority for the incident")
        this.$refs['priority'].classList.add('invalid')
      }
      if (!selectedResidentVerified) {
        warnings.push("Select an associated Resident")
        this.$refs['resident'].classList.add('invalid')
      }
      if (!selectedAssigneeVerified) {
        warnings.push("Select an Assignee")
        this.$refs['assignee'].classList.add('invalid')
      }

      if (warnings.length != 0) {
        alert(warnings.join('\n'))
        return false
      }
      return true
    },
    async fetchResidents(data) {
      if (this.$props.organizationData == null) return
      new CTSRepository({
        organization_id: this.organizationData.organization_id
      }).fetchResidents(data).then(async (responseData) => {
        console.log("Search Data", responseData);
        let mappedData = await responseData.data.map(item => {
          return {
            name: `${item.first_name} ${item.last_name}${item.address ? ` - ${item.address}` : ''}`,
            value: item,
            key: item.uid
          }
        });
        console.log("Mapped Data", mappedData);
        let guards = responseData.data.filter(item => item.role == 'guard' || item.role == 'hoa_admin')
        let mappedGuards = guards.map(item => {
          return {
            name: `${item.first_name} ${item.last_name}${item.address ? ` - ${item.address}` : ''}`,
            value: item,
            key: item.uid
          }
        });
        this.residentOptions = mappedData
        this.guardOptions = mappedGuards
      }).catch(() => {

      });

    },
    // TODO: FIX LOCATION QUERY ON API
    fetchLocations() {
      new CTSRepository(this.$props.organizationData).fetchLocations()
        .then((data) => {
          console.log("CREATE INCIDENT - Location Data", data);
          //this.locations = data.data
        })
        .catch((err) => {
          console.error("Error with fetching locations", err)
        });
    },
    createIncident() {
      if (!this.inputsValid()) {
        return;
      }
      const body = {
        "resident_uid": this.residentData.uid,
        "incident_type": this.selectedType,
        "incident_title": this.title,
        "description": this.description,
        "reporter": this.$props.userData.sub,
        "current_status": this.selectedStatus,
        "priority": this.selectedPriority,
        "location": this.selectedLocation,
        "assignee": this.assigneeData.uid
      }
      // TODO: Adjust assignee
      new CTSRepository(this.$props.organizationData).createIncident(
        JSON.stringify(body)
      ).then((data) => {
        console.log("Search Data", data);
        this.close()
      })
    }
  },
  created() {
    console.log("In modal")
    console.log("Create Incident Modal Params", this.$$props)
  },
  mounted() {
    this.fetchResidents("")
  },
  computed: {
    mappedTypes: function () {
      const arrayToMap = this.filteredTypes ?? this.types
      return arrayToMap.map(item => {
        return {
          name: item,
          value: item
        }
      });
    },
    mappedStatuses: function () {
      const arrayToMap = this.filteredStatuses ?? this.statuses
      return arrayToMap.map(item => {
        return {
          name: item,
          value: item
        }
      });
    },
    mappedPriorities: function () {
      const arrayToMap = this.filteredPriorities ?? this.priorities
      return arrayToMap.map(item => {
        return {
          name: item,
          value: item
        }
      });
    },
    mappedLocations: function () {
      const arrayToMap = this.filteredLocations ?? this.locations
      return arrayToMap.map(item => {
        return {
          name: item.location_name,
          value: item.location_name
        }
      });
    }
  }
}
</script>

<style scoped>
.modal-incident-title {
  font-size: 24px;
  margin-bottom: 18px;
  border-bottom: 1px solid black;
  text-decoration: none;
  outline: 0;
}

.modal-incident-title::placeholder {
  color: #d9d9d988;
}

.modal-incident-description {
  font-size: 14px;
  font-weight: lighter;
  border-bottom: 1px solid black;
  text-decoration: none;
  outline: 0;
  margin-bottom: 18px;
  resize: none;

}

.modal-incident-description::placeholder {
  color: #d9d9d988;
}


.modal-create-data-item button {
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: #ccd9d9d9;
}

.invalid {
  outline: 1px solid red;
}
</style>